import { capitalize } from './capitalize';
import { animals } from './create-avatar';
import { seededRandom } from './seeded-random';

const adjectives = [
  'adventurous',
  'agile',
  'amazing',
  'ambitious',
  'amused',
  'ancient',
  'aspiring',
  'attractive',
  'awesome',
  'beautiful',
  'blessed',
  'calm',
  'capable',
  'careful',
  'caring',
  'cautious',
  'charming',
  'cheerful',
  'classy',
  'colorful',
  'conscious',
  'courageous',
  'curious',
  'delightful',
  'determined',
  'discreet',
  'dreamy',
  'driven',
  'eager',
  'educated',
  'elegant',
  'energized',
  'excited',
  'exotic',
  'fabulous',
  'famous',
  'fancy',
  'fearless',
  'friendly',
  'fluffy',
  'funny',
  'futuristic',
  'gentle',
  'giant',
  'glamorous',
  'glossy',
  'gorgeous',
  'graceful',
  'grateful',
  'groovy',
  'happy',
  'harmonious',
  'helpful',
  'hilarious',
  'hungry',
  'hypnotic',
  'incredible',
  'intelligent',
  'invincible',
  'joyful',
  'kind',
  'likeable',
  'loyal',
  'lucky',
  'magical',
  'majestic',
  'melodic',
  'modest',
  'nervous',
  'noble',
  'outgoing',
  'peaceful',
  'pleasant',
  'poetic',
  'powerful',
  'productive',
  'pumped',
  'quick',
  'rapid',
  'remarkable',
  'romantic',
  'royal',
  'scientific',
  'sharp',
  'smart',
  'smiley',
  'smooth',
  'social',
  'stormy',
  'sweet',
  'talented',
  'tasteful',
  'thankful',
  'thoughtful',
  'tough',
  'tropical',
  'uplifting',
  'vocal',
  'wild',
  'wise',
];

export const getAnonymousGuestName = (seed: string) => {
  if (!seed) return 'Anonymous';
  const adjectiveIndex = Math.floor(seededRandom(seed) * adjectives.length);
  const animalIndex = Math.floor(seededRandom(seed + 'a') * animals.length);
  return [adjectives[adjectiveIndex], animals[animalIndex]].map(a => capitalize(a)).join(' ');
};
